import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { map, filter, size } from 'lodash';
import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Label from 'reactstrap/lib/Label';

import moment from 'moment';
import Moment from 'react-moment';

import momentLocalizer from 'react-widgets-moment';

// import member from '../../../store/member';
import * as constants from '../../../../../../constants/constants';

import treeSvg from '../../../../../../images/icons/tree-svg.svg';
import reminderImg from '../../../../../../images/redesign/common/game.png';
import coinImg from '../../../../../../images/coin.svg';

import { Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import closeImg from '../../../../../../images/icons/close.png';

import { getTournamentActiveRooms, returnToTournament } from '../../../../../../actions/tournaments';
import CustomModal from '../../../Components/Components/Modal';
import TournamentTimer from '../../Tournaments/Components/TournamentTimer';

moment.locale('lv');
momentLocalizer();

class TournamentPauseModalMobile extends React.Component {
    static propTypes = {
      t: PropTypes.func.isRequired,
      member: PropTypes.shape({}),
      registeredTournament: PropTypes.string,
      fontMode: PropTypes.string,
    }

    constructor(props) {
      super(props);
      this.state = {
        returnConfirmationOpen: false,
        popoverEndTime: 0,
      };
    }

    componentDidMount() {
        const { fetchTournamentActiveRooms, tournaments, offset: offsetVal, myTournamentsData } = this.props;

        if (myTournamentsData.tournamentId) {
            fetchTournamentActiveRooms(myTournamentsData.tournamentId).then((res) => {
                const tournament = tournaments.find(element => element.id === myTournamentsData.tournamentId);

                console.log('fetchTournamentActiveRooms res.data', res.data);

                if (res && res.data) {
                    const roomsCount = Object.keys(res.data).length;
                    let partiesCount = 0;

                    Object.keys(res.data).map((key) => {
                        if (res.data[key] && res.data[key].party) {
                            partiesCount += parseInt(res.data[key].party, 10);
                        }
                        return null;
                    });

                    console.log('gameStartTime tournament', tournament);

                    const { roundLength, gameStartTime, lightningGame, fastGame, veryFastGame } = tournament;
                    let { roundLengthTime } = tournament;
                    const averageParties = partiesCount / roomsCount;
                    const averagePartiesLeft = Math.round(parseInt(roundLength, 10) - averageParties);

                    // console.log('gameStartTime', gameStartTime);

                    let speed = 'normal';

                    if (fastGame) {
                        speed = 'atra';
                    } else if (lightningGame) {
                        speed = 'lightning';
                    } else if (veryFastGame) {
                        speed = 'veryFast';
                    }

                    if (!roundLengthTime) {
                        roundLengthTime = constants.CALC_TOURNAMENT_ROUND_LENGTH(roundLength, speed);
                    }

                    let gameEndTime = gameStartTime + (roundLengthTime * 60 * 1000);

                    /*if (roundLength > 24) {
                    gameEndTime = gameStartTime + (60 * 60 * 1000);
                    } else if (roundLength > 12) {
                    gameEndTime = gameStartTime + (40 * 60 * 1000);
                    } */

                    console.log('gameEndTime', gameEndTime);

                    if (gameEndTime) {
                        const gameLength = gameEndTime - (Date.now() + offsetVal);
                        const minutes = Math.floor((gameLength % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((gameLength % (1000 * 60)) / 1000);

                        if (minutes >= 0 && seconds >= 0) {
                            this.setState({
                            minutes: minutes < 10 ? `0${minutes}` : minutes,
                            seconds: seconds < 10 ? `0${seconds}` : seconds,
                            });
                        }
                    }

                    this.intervalID = setInterval(() => {
                        const { offset, gameStartTime } = this.props;

                        let gameEndTime = gameStartTime + (roundLengthTime * 60 * 1000);

                        console.log('time', gameEndTime, this.props);

                        if (gameEndTime) {
                            const gameLength = gameEndTime - (Date.now() + offset);
                            const minutes = Math.floor((gameLength % (1000 * 60 * 60)) / (1000 * 60));
                            const seconds = Math.floor((gameLength % (1000 * 60)) / 1000);

                            if (minutes >= 0 && seconds >= 0) {
                            this.setState({
                                minutes: minutes < 10 ? `0${minutes}` : minutes,
                                seconds: seconds < 10 ? `0${seconds}` : seconds,
                            });
                            }
                        }
                    }, 1000);

                    this.setState({
                        popoverOpen: myTournamentsData.tournamentId,
                        time: gameEndTime,
                        popoverRoomsCount: roomsCount,
                        popoverPartiesCount: roomsCount > 0 ? averagePartiesLeft : 0,
                    });
                }
            });
        }

    }

    
    toggleReturnConfirmationOpen = () => {
        const { returnConfirmationOpen } = this.state;
        this.setState({
            returnConfirmationOpen: !returnConfirmationOpen,
        })
    }


    fetchTournamentActiveRooms = (tournamentId) => {
        const { fetchTournamentActiveRooms, tournaments } = this.props;
        const { popoverOpen } = this.state;

        if (popoverOpen && popoverOpen === tournamentId) {
            this.setState({ popoverOpen: null });
        } else if (tournamentId) {
            fetchTournamentActiveRooms(tournamentId).then((res) => {
                const tournament = tournaments.find(element => element.id === tournamentId);

                console.log('fetchTournamentActiveRooms res.data', res.data);

                if (res && res.data) {
                const roomsCount = Object.keys(res.data).length;
                let partiesCount = 0;

                Object.keys(res.data).map((key) => {
                    if (res.data[key] && res.data[key].party) {
                    partiesCount += parseInt(res.data[key].party, 10);
                    }
                    return null;
                });

                console.log('gameStartTime tournament', tournament);

                const { roundLength, gameStartTime, lightningGame, fastGame, veryFastGame } = tournament;
                let { roundLengthTime } = tournament;
                const averageParties = partiesCount / roomsCount;
                const averagePartiesLeft = Math.round(parseInt(roundLength, 10) - averageParties);

                console.log('gameStartTime', gameStartTime);

                let speed = 'normal';

                if (fastGame) {
                    speed = 'atra';
                } else if (lightningGame) {
                    speed = 'lightning';
                } else if (veryFastGame) {
                    speed = 'veryFast';
                }

                if (!roundLengthTime) {
                    roundLengthTime = constants.CALC_TOURNAMENT_ROUND_LENGTH(roundLength, speed);
                }

                let gameEndTime = gameStartTime + (roundLengthTime * 60 * 1000);

                /*if (roundLength > 24) {
                    gameEndTime = gameStartTime + (60 * 60 * 1000);
                } else if (roundLength > 12) {
                    gameEndTime = gameStartTime + (40 * 60 * 1000);
                } */

                console.log('gameEndTime', gameEndTime);

                this.setState({
                    popoverOpen: tournamentId,
                    popoverEndTime: gameEndTime,
                    popoverRoomsCount: roomsCount,
                    popoverPartiesCount: roomsCount > 0 ? averagePartiesLeft : 0,
                });
                }
            });
        }
    }

    render() {
        const { t, i18n, fontMode, tournaments, myTournamentsData, returnToTournamentFunc, fetchTournamentActiveRooms, offset, disableModal } = this.props;
        const { returnConfirmationOpen, popoverEndTime } = this.state;

        const curTournament = tournaments.find(item => item.id === myTournamentsData.tournamentId);
        if (curTournament?.rounds === curTournament?.currentRound) return null;

        return (
            <>
                <div className="event-section event-section-mobile event-section-mobile-show" style={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}}>
                    <div className="event-header" style={{height: 'auto', maxHeight: 'calc(100vh - 71px)'}}>
                        <div className="event-title">
                            {i18n.language === 'en' ? curTournament?.titleEN : (i18n.language === 'lv' ? curTournament?.titleLV : (i18n.language === 'ru' ? curTournament?.titleRU : curTournament?.titleLV))}
                        </div>
                        <div className="event-close events-header-close" onClick={() => disableModal()}>x</div>

                        <div className="event-description">
                            {myTournamentsData?.inactivityPaused ? t('tournaments.pauseModalTextInactivity') : t('tournaments.pauseModalText')}
                            <br />
                            <br />

                            <div style={{opacity: curTournament.currentState === 'play' ? 0 : 1}}>
                                {(
                                    curTournament.rounds !== curTournament.currentRound ? (
                                        <>
                                            {t('tournaments.pausedNewRoundAfterModal', { round: curTournament.currentRound })}
                                            <TournamentTimer key={curTournament.pauseUntil} t={t} time={curTournament.pauseUntil || 0} offset={offset} />
                                        </>
                                    ) : (
                                        <>
                                            {t('tournaments.pausedNewRoundAfterModal', { round: curTournament.currentRound })}
                                            <TournamentTimer key={curTournament.pauseUntil} t={t} time={curTournament.pauseUntil || 0} offset={offset} />
                                        </>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                    
                    <div className="event-footer">
                        <Button className="event-footer-button" color="secondary" onClick={(e) => { this.toggleReturnConfirmationOpen(); }}>
                            <Media src={treeSvg} className="event-tree-svg-before" />
                            <label className="openPage">{t('tournaments.return')}</label>
                            <Media src={treeSvg} className="event-tree-svg-end" />
                        </Button>
                    </div>
                </div>

                <CustomModal
                    isOpen={returnConfirmationOpen}
                    toggle={this.toggleReturnConfirmationOpen}
                    size="md"
                    verticalCentering
                    largeText
                    title={t('home.confirm')}
                    footer={(
                        <>
                            <Button className="question-modal-approve-btn" onClick={(e) => { returnToTournamentFunc(curTournament.id); e.target.blur(); this.toggleReturnConfirmationOpen(); }}>
                                {t('common.yes')}
                            </Button>
                            <Button className="question-modal-decline-btn" onClick={this.toggleReturnConfirmationOpen}>
                                {t('common.no')}
                            </Button>
                        </>
                    )}
                    body={(
                        <p className="text-center">
                            {t('tournaments.returnConfirmation')}
                        </p>
                    )}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    member: state.member || null,
    tournaments: (state.tournaments && state.tournaments.tournaments) ? state.tournaments.tournaments : [],
    myTournamentsData: (state.tournaments && state.tournaments.myTournamentsData) ? state.tournaments.myTournamentsData : {},
    offset: state.member.offset || 0,
});

const mapDispatchToProps = {
    returnToTournamentFunc: returnToTournament,
    fetchTournamentActiveRooms: getTournamentActiveRooms,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(TournamentPauseModalMobile));
